import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isSafeToReload, watchForActivation } from '../lib/sw-update.js';

/**
 * Reloads the app once a newly deployed service worker has taken over (see lib/sw-update).
 *
 * Renders nothing. It lives inside the router because the decision it makes — is this a
 * moment where a reload is acceptable — is a question about the current route, and
 * `useLocation` is the only honest answer: React Router navigations do not emit
 * `popstate`, so a listener outside the router would still be looking at the path the
 * passenger was on when the app booted.
 */
export function AppUpdater() {
  const { pathname } = useLocation();
  const pending = useRef(false);
  // Read inside the effect rather than closed over, so the watcher is installed once
  // instead of being torn down and re-created on every navigation.
  const currentPath = useRef(pathname);
  currentPath.current = pathname;

  useEffect(() => {
    return watchForActivation({
      onActivated: () => {
        if (isSafeToReload(currentPath.current)) window.location.reload();
        else pending.current = true;
      },
    });
  }, []);

  // A reload held back during checkout happens as soon as the passenger leaves it.
  useEffect(() => {
    if (pending.current && isSafeToReload(pathname)) window.location.reload();
  }, [pathname]);

  return null;
}
